<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-09-28 09:21:32
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-28 14:40:32
-->
<template>
  <div>
    <el-form-item label="选择字段">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="onSetting"
      >选择</el-button>
    </el-form-item>

    <div style="margin: 10px 0">
      <el-table
        :data="data.option.column"
        v-loading="waitting"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column
          label="字段名"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.prop }}
            <span v-if="scope.row.label">（{{ scope.row.label }}）</span>
          </template>
        </el-table-column>

        <el-table-column
          label="展示类型"
          align="center"
        >
          <template slot-scope="scope">
            <template v-for="(item, index) in showType">
              <span
                v-if="scope.row.type === item.value"
                :key="index"
                :label="item.value"
              >{{ item.label }}</span>
            </template>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-top"
              @click="sortField(scope.row, scope.$index, 'up')"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-bottom"
              @click="sortField(scope.row, scope.$index, 'down')"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="editField(scope.row, scope.$index)"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="deleteField(scope.row, scope.$index, onRefresh)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 选择字段弹窗 -->
    <card-field-dialog
      :loading="loading"
      :dialog="dialog"
      :data="data"
      :column="column"
      :showType="showType"
      @change="updateField($event, onRefresh)"
    />
  </div>
</template>
<script>
import apiField from '@/dragComponents/mixins/apiField.js'
import { cardConfig } from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'

import cardFieldDialog from './fieldDialog.vue'
export default {
  name: 'card-field',
  mixins: [apiField],
  components: {
    cardFieldDialog
  },
  props: {
    data: {
      type: [Array, Object]
    },
    showType: {
      type: Array,
      default: cardConfig.showType
    }
  },
  data() {
    return {}
  },
  watch: {
    'data.prop': {
      handler() {
        if (!isEmpty(this.data.apiId)) {
          this.loadFeild()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSetting() {
      let form = Object.assign(
        {
          label: '',
          prop: '',
          type: 'value',
          title: ''
        },
        cardConfig.attrs
      )
      this.addField(form)
    },
    onRefresh() {
      this.data.option.refresh = true
    }
  }
}
</script>
